export enum AnalyticsActionTypes {
    GET_HISTORIC_DATA_REQUEST_IN_PROGRESS = 'GET_HISTORIC_DATA_REQUEST_IN_PROGRESS',
    GET_HISTORIC_DATA_REQUEST_SUCCESS = 'GET_HISTORIC_DATA_REQUEST_SUCCESS',
    GET_HISTORIC_DATA_REQUEST_FAILURE = 'GET_HISTORIC_DATA_REQUEST_FAILURE',
}
